import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = { class: "document-type-grid" };
const _hoisted_2 = ["src", "alt"];
const _hoisted_3 = { class: "lozenge-label" };
import { computed } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'DocumentTypeGrid',
    setup(__props) {
        const categoryNames = ['Home', 'Family', 'Banking', 'Investments', 'Vehicles', 'Travel', 'Work', 'Tax', 'Health', 'Subscriptions', 'Pets', 'Important', 'Personal', 'Other'];
        function getDocumentCategoryImage(category) {
            const map = {
                'Home': require('@/assets/doc-categories/home.png'),
                'Family': require('@/assets/doc-categories/family.png'),
                'Banking': require('@/assets/doc-categories/banking.png'),
                'Investments': require('@/assets/doc-categories/investments.png'),
                'Vehicles': require('@/assets/doc-categories/vehicle.png'),
                'Travel': require('@/assets/doc-categories/travel.png'),
                'Work': require('@/assets/doc-categories/work.png'),
                'Tax': require('@/assets/doc-categories/tax.png'),
                'Health': require('@/assets/doc-categories/health.png'),
                'Subscriptions': require('@/assets/doc-categories/subscriptions.png'),
                'Personal': require('@/assets/doc-categories/personal.png'),
                'Pets': require('@/assets/doc-categories/pets.png'),
                'Important': require('@/assets/doc-categories/important.png'),
            };
            return map[category] || require('@/assets/doc-categories/other.png');
        }
        const categories = computed(() => {
            return categoryNames.map(name => ({
                label: name,
                icon: getDocumentCategoryImage(name)
            }));
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categories.value, (cat) => {
                    return (_openBlock(), _createElementBlock("div", {
                        key: cat.label,
                        class: "doc-type-lozenge"
                    }, [
                        _createElementVNode("img", {
                            src: cat.icon,
                            alt: cat.label,
                            class: "lozenge-icon"
                        }, null, 8, _hoisted_2),
                        _createElementVNode("p", _hoisted_3, _toDisplayString(cat.label), 1)
                    ]));
                }), 128))
            ]));
        };
    }
});
